import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ResetPasswordPage } from '@/pages/reset-password/reset-password-page';

const ResetPasswordSearchSchema = z.object({
  token: z.string().min(8),
});

export const Route = createFileRoute('/reset-password')({
  component: ResetPasswordPage,
  validateSearch: ResetPasswordSearchSchema,
});
